window.addEventListener(
  'click',
  (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const cartLink = event.target.closest('a[href]');
    if (!cartLink) return;

    const url = new URL(cartLink.href, window.location.origin);
    if (url.origin === window.location.origin && /\/cart\/?$/.test(url.pathname)) {
      event.preventDefault();
    }
  }
);

window.addEventListener('load', () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('open-essential-cart')) return;

  url.searchParams.delete('open-essential-cart');
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  document.querySelector('#cart-icon-bubble')?.click();
});
